var _defs, _g, _g2, _g3, _g4, _path, _path2, _path3, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningiconwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        filter: url(#drop-shadow-18);\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        opacity: .4;\n      }\n\n      .st3 {\n        fill: none;\n      }\n\n      .st4 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st5 {\n        opacity: .2;\n      }\n\n      .st6 {\n        fill: #8030c7;\n      }\n\n      .st7 {\n        clip-path: url(#clippath);\n      }\n\n      .st8 {\n        fill: #9234e0;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-18",
    x: 265.3,
    y: 475.4,
    width: 2417.3,
    height: 876.7,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 1624,
    y: 521.5,
    width: 647,
    height: 538.7,
    rx: 15.6,
    ry: 15.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: -1020.1,
    y: -125.7,
    width: 647,
    height: 686.2,
    rx: 15.6,
    ry: 15.6
  })), /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 1440,
    height: 400,
    xlinkHref: "../Dropbox/Matthew Schutz/[Creative Projects]/[LOOKSFLY]/PROJECTS/MePrism/2025/ui app user flow/after effects/modals/Gradient+BG (1).jpg"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(2682.5 1352.1) rotate(-180) scale(1.7 2.2)",
    xlinkHref: "#image"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(195.4 569.3) rotate(-180) scale(1.4 1.8)",
    xlinkHref: "#image"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M462.9,126.2c-1-14.7-9.8-27.7-23.1-34L267.4,10.3c-11-5.2-23.9-5.2-34.9,0L60.2,92.2c-13.3,6.3-22.2,19.3-23.1,34-16.2,249.9,144.1,341,196.6,364,10.4,4.6,22.3,4.6,32.7,0,52.5-23,212.8-114.1,196.6-364Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M431.6,144.4c-.8-12.5-8.4-23.6-19.7-29l-147-69.8c-9.4-4.5-20.3-4.5-29.8,0L88.1,115.4c-11.3,5.4-18.9,16.5-19.7,29-13.8,213.1,122.9,290.8,167.7,310.4,8.9,3.9,19,3.9,27.9,0,44.8-19.6,181.4-97.3,167.7-310.4Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.5,162.5c-.7-10.4-6.9-19.6-16.4-24.1l-121.8-57.9c-7.8-3.7-16.9-3.7-24.7,0l-121.8,57.9c-9.4,4.5-15.7,13.7-16.4,24.1-11.4,176.7,101.8,241,139,257.3,7.4,3.2,15.7,3.2,23.1,0,37.1-16.3,150.4-80.6,139-257.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M325.8,332.9c-25.5,32.5-55.3,49.9-72.8,58-1.1.5-2.3.7-3.5.6-.9,0-1.8-.3-2.6-.6-17.5-8.1-47.3-25.5-72.7-58-33.4-42.6-48.7-97.6-45.3-163.5.1-2.6,1.7-5,4.1-6.1l113.9-54.1c.8-.4,1.7-.6,2.6-.7,1.2,0,2.4.1,3.5.7l113.9,54.1c2.4,1.1,3.9,3.5,4.1,6.1,3.4,65.9-11.9,120.9-45.3,163.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M325.8,332.9c-25.5,32.5-55.3,49.9-72.8,58-1.1.5-2.3.7-3.5.6V108.5c1.2,0,2.4.1,3.5.7l113.9,54.1c2.4,1.1,3.9,3.5,4.1,6.1,3.4,65.9-11.9,120.9-45.3,163.5Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250,185c-23,0-41.7,18.7-41.7,41.7v3.7h15.2v-3.7c0-14.6,11.9-26.6,26.6-26.6s26.6,11.9,26.6,26.6v3.7h15.2v-3.7c0-23-18.7-41.7-41.7-41.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.3,237.5h-94.5c-2.9,0-5.2,2.3-5.2,5.2v67.1c0,2.9,2.3,5.2,5.2,5.2h94.5c2.9,0,5.2-2.3,5.2-5.2v-67.1c0-2.9-2.3-5.2-5.2-5.2ZM253.7,279.4l1.8,16.7h-10.9l1.8-16.7c-4.4-1.5-7.5-5.6-7.5-10.5s5-11.2,11.2-11.2,11.2,5,11.2,11.2-3.1,9-7.5,10.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningiconwhite);
export default __webpack_public_path__ + "static/media/warningiconwhite.7d0aaff00f53e985ddbab2d56b8ced00.svg";
export { ForwardRef as ReactComponent };